import styled, { css } from 'styled-components';

export const StyledLabel = styled.label`
  display: block;
  font-size: 14px;
  line-height: 18px;
  font-weight: 600;
  /* Paired with surfaces: ink on paper, remapped on [data-surface=dark] */
  color: var(--text-main);
  text-align: left;
  margin-bottom: 10px;

  pointer-events: ${({ $onlyRead }) => $onlyRead && 'none'};
  ${({ labelIcon }) =>
    labelIcon &&
    css`
      display: flex;
      align-items: center;
    `}
  ${({ $labelReverse }) =>
    $labelReverse &&
    css`
      position: relative;
      .label {
        flex-direction: row-reverse;
      }
    `};
  .label {
    display: flex;
    /* align-items: center; */
  }
`;

export const RequiredAsterisk = styled.span`
  color: var(--danger);
  font-size: 14px;
`;
